import { useBlobStore } from '../state/blobStore';
import { ageBandLabel } from '../lib/bandLookup';

export type HoverInfo = {
  x: number;
  y: number;
  id: string;
  name: string;
  ageBand: number;
  regionCode: string;
};

type Props = HoverInfo;

export default function HoverTooltip({ x, y, id, name, ageBand, regionCode }: Props) {
  const blob = useBlobStore((s) => s.blob);
  const shortId = id.slice(0, 8);
  const displayName = name || `Person ${shortId}`;
  const ageLabel = ageBandLabel(blob, ageBand);
  return (
    <div
      className="hover-tooltip"
      style={{ left: x + 12, top: y + 12 }}
      role="tooltip"
    >
      <div className="hover-tooltip__id">{displayName}</div>
      <div className="hover-tooltip__row">{ageLabel}</div>
      <div className="hover-tooltip__row">{regionCode}</div>
    </div>
  );
}
